import { alreadySomeFanticketUpgrades } from "~/lib/utils";
import { useShopConfig } from "~/hooks/useShopConfig";
import { useCart } from "~/hooks/useCart";
import { EventOrBundle } from "~/lib/definitions";
import { useCallback } from "react";

export function useNewItemIsInstantlyUpgraded() {
  const {
    shopConfig: { fanTicket },
  } = useShopConfig();

  const items = useCart(({ items }) => items);

  return useCallback(
    (item: EventOrBundle) => {
      const isItemUpgradeable =
        Number(fanTicket?.eventIds?.length) > 0 &&
        (item.case === "event"
          ? fanTicket?.eventIds?.includes(item.value.id)
          : item.value?.eventIds.every((eventId) =>
              fanTicket?.eventIds?.includes(eventId),
            ));

      return (
        (alreadySomeFanticketUpgrades(items) && isItemUpgradeable) ?? false
      );
    },
    [fanTicket, items],
  );
}
